





































import {Component, Mixins} from 'vue-property-decorator';
import ProductInquiryMethodsMixin from '@/components/product/ProductInquiryMethodsMixin';
import ProductInquiryContent from '@/components/product/ProductInquiryContent.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import PageSizeData from '@/components/board/mixins/PageSizeData';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import PageContentBottom from '@/components/board/common/PageBottomProductInquiryContent.vue';
import ProductListSlotRight from '@/components/product/ProductListSlotRight.vue';
import ProductInquiryOrderInfo from '@/components/product/ProductInquiryOrderInfo.vue';
import ProductInquiryReplied from '@/components/product/ProductInquiryReplied.vue';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

@Component({
  components: {
    ProductInquiryContent,
    PageTitle,
    PageSizeData,
    PageFormSelect,
    PageDateFilterBtns,
    PageDateRangePicker,
    PageFormBtn,
    PageContentBottom,
    ProductListSlotRight,
    ProductInquiryOrderInfo,
    ProductInquiryReplied,
    ExcelCreateButton
  }
})
export default class ProductInquiry extends Mixins(ProductInquiryMethodsMixin, PageSizeData) {}
